import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, CircularProgress, Typography, withStyles, Fade } from '@material-ui/core';
import logo from '../../images/Presense/Logo/logo-air.png';
import Swal from 'sweetalert2';

// import * as Icons from '@material-ui/icons';

export class QrcodeBed extends Component {
  async componentDidMount() {
    try {
      const { bedId, status } = this.props.match.params;
      if (status === 'on' || status === 'off') {
        const device = await this.props.qrcode.getBed(+bedId, status);
        if (device) {
          device.status = status === 'on' ? 'ACTIVATE_ON' : 'ACTIVATE_OFF';
          const response = await this.props.qrcode.updateDevice(device);
          if (response) {
            Swal.fire({
              type: 'success',
              title: response.status === 'ACTIVATE_ON' ? 'Successfully Activated ON' : 'Successfully Activated OFF',
            });
          }
        }
      } else {
        Swal.fire({
          type: 'error',
          title: 'Wrong Status',
        });
      }
    } catch (error) {
      Swal.fire({
        type: 'error',
        title: error.message,
      });
    }
  }

  render() {
    const { classes } = this.props;
    let { loading, status } = this.props.qrcode.toJS();
    return (
      <Grid container className={classes.container}>
        <div className={classes.logotypeContainer}>
          <img src={logo} alt='logo' className={classes.logotypeImage} />
          <Typography className={classes.logotypeText}>Pre-sense System</Typography>
        </div>
        <div className={classes.formContainer}>
          <div className={classes.form}>
            <React.Fragment>
              {loading && (
                <center>
                  <CircularProgress size={100} className={classes.loginLoader} />
                </center>
              )}
              <Fade in={true}>
                <Typography color={status.error ? 'secondary' : 'primary'} className={classes.errorMessage}>
                  {status.message}
                </Typography>
              </Fade>
            </React.Fragment>
          </div>
          <Typography color='primary' className={classes.copyright}>
            © Copyright 2024 Emetworks.
          </Typography>
        </div>
      </Grid>
    );
  }
}

const styles = (theme) => ({
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  logotypeContainer: {
    backgroundColor: theme.palette.primary.main,
    width: '60%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  logotypeImage: {
    width: 165,
    marginBottom: theme.spacing.unit * 4,
  },
  logotypeText: {
    color: 'white',
    fontWeight: 500,
    fontSize: 84,
    [theme.breakpoints.down('md')]: {
      fontSize: 48,
    },
  },
  formContainer: {
    width: '40%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
  },
  form: {
    width: 320,
  },
  tab: {
    fontWeight: 400,
    fontSize: 18,
    color: '#009688',
  },
  greeting: {
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing.unit * 4,
  },
  subGreeting: {
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing.unit * 2,
  },
  googleButton: {
    marginTop: theme.spacing.unit * 6,
    boxShadow: theme.customShadows.widget,
    backgroundColor: 'white',
    width: '100%',
    textTransform: 'none',
  },
  googleButtonCreating: {
    marginTop: 0,
  },
  googleIcon: {
    width: 30,
    marginRight: theme.spacing.unit * 2,
  },
  creatingButtonContainer: {
    marginTop: theme.spacing.unit * 2.5,
    height: 46,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  createAccountButton: {
    height: 46,
    textTransform: 'none',
  },
  formDividerContainer: {
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 4,
    display: 'flex',
    alignItems: 'center',
  },
  formDividerWord: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
  },
  formDivider: {
    flexGrow: 1,
    height: 1,
    backgroundColor: theme.palette.text.hint + '40',
  },
  errorMessage: {
    textAlign: 'center',
    marginTop: '30px',
    fontSize: '1.575rem',
  },
  textFieldUnderline: {
    '&:before': {
      borderBottomColor: theme.palette.primary.light,
    },
    '&:after': {
      borderBottomColor: theme.palette.primary.main,
    },
    '&:hover:before': {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderBottomColor: theme.palette.background.light,
  },
  formButtons: {
    width: '100%',
    marginTop: theme.spacing.unit * 4,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  forgetButton: {
    textTransform: 'none',
    fontWeight: 400,
  },
  loginLoader: {
    marginLeft: theme.spacing.unit * 4,
  },
  copyright: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
  },
  button: {
    width: '100%',
  },
});

export const page = inject('qrcode')(observer(QrcodeBed));
export default withStyles(styles, { withTheme: true })(page);
